import { defineMessages } from 'react-intl';

export default defineMessages({
  logout: {
    id: 't.app.global.exit',
    defaultMessage: 'Exit',
  },
  program: {
    id: 't.app.header.program.anchor',
    defaultMessage: 'Program',
  },
  ourOffer: {
    id: 't.app.header.ourOffer.anchor',
    defaultMessage: 'Our offer',
  },
  services: {
    id: 't.app.header.services.anchor',
    defaultMessage: 'services',
  },
  support: {
    id: 't.app.header.support.anchor',
    defaultMessage: 'Support',
  },
  settings: {
    id: 't.app.header.settings.anchor',
    defaultMessage: 'settings',
  },
  contact: {
    id: 't.app.header.contact.anchor',
    defaultMessage: 'contact',
  },
  switchPosition: {
    id: 't.app.header.switchPosition.button',
    defaultMessage: 'Switch position',
  },
  currentPosition: {
    id: 't.app.header.currentPosition.title',
    defaultMessage: 'Current position:'
  }
});
